module.exports = __webpack_public_path__ + "static/reczebteething-bce354f181c36f60dded789a21b91f60.png";